@if (reminders$) {
    <table class="reminders-table">
        <thead>
            <tr>
                <th class="reminders-name-th" title="Nom">Nom</th>
                <th class="reminders-next-occurence-th" title="Prochaine occurence">Prochaine occurence</th>
                <th class="reminders-frequency-th" title="Frequence">Intervalle</th>
                <th class="reminders-remaining-occurence-th" title="Occurences restantes">Occurences restantes</th>
                <th class="reminders-action-type-th" title="Type d'action">Type d'action</th>
                <th class="actions-th"></th>
            </tr>
        </thead>
        <tbody>
            @for (reminder of reminders$ | async; track reminder.id) {
                <tr>
                    <td class="reminders-name-td" [title]="reminder.name">{{ reminder.name }}</td>
                    <td class="reminders-next-occurence-td" [title]="reminder.nextOccurenceDate | date: FRENCH_DATETIME_WITHOUT_SECONDS_FORMAT">
                        {{ reminder.nextOccurenceDate | date: FRENCH_DATETIME_WITHOUT_SECONDS_FORMAT }}
                    </td>
                    <td class="reminders-frequency-td" [title]="reminder.intervalRepeat">{{ reminder.intervalRepeat }}</td>
                    <td class="reminders-remaining-occurence-td" [title]="reminder.remainingOccurence">
                        @if (reminder.remainingOccurence !== 0) {
                            <span [class.infinite]="reminder.occurenceFrequency !== null && reminder.maxOccurence === null">{{ reminder.remainingOccurence }}</span>
                        }
                    </td>
                    <td
                        class="reminders-action-type-td"
                        [title]="reminder.actionType === ReminderActionType.DisplayNotification ? 'Affichage d\'une notification' : 'Envoi d\'un mail'">
                        @switch (reminder.actionType) {
                            @case (ReminderActionType.DisplayNotification) {
                                <span>Affichage d'une notification</span>
                            }
                            @case (ReminderActionType.SendMail) {
                                <span>Envoi d'un mail</span>
                            }
                        }
                    </td>
                    <td class="actions-td">
                        <div class="buttons-container">
                            <mat-icon-button
                                class="basic-button"
                                aria-label="Éditer"
                                matTooltip="Éditer"
                                matTooltipPosition="below"
                                (click)="$event.stopPropagation(); editReminder(reminder)">
                                <fa-icon [icon]="editIcon"></fa-icon>
                            </mat-icon-button>
                            <mat-icon-button
                                mat-mini-fab
                                class="basic-button"
                                aria-label="Supprimer"
                                matTooltip="Supprimer"
                                matTooltipPosition="below"
                                (click)="$event.stopPropagation(); deleteReminder(reminder)">
                                <fa-icon [icon]="deleteIcon"></fa-icon>
                            </mat-icon-button>
                        </div>
                    </td>
                </tr>
            }
        </tbody>
        <ngx-spinner name="reminder-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </table>
}
